<template>
  <v-layout row wrap>
    <v-flex xs6>
      <Card class="availability-card">
        <v-container grid-list-md text-xs-center class="pa-0 ma-0">
          <div class="pa-0 ma-0 d-flex align-center">
            <v-flex xs5>
              <div v-if="widgetList.length">
                <div v-for="item in widgetList" :key="item.name">
                  <div class="card-title">{{ $t(item.name) }} (%)</div>
                  <v-progress-circular
                    :rotate="360"
                    :size="65"
                    :width="5"
                    :value="item.value"
                    color="#E9952A"
                  >
                    {{ widgetData[item.name] }}
                  </v-progress-circular>
                </div>
              </div>
            </v-flex>
            <v-divider vertical class="custom-divider"></v-divider>
            <v-flex xs8 class="pa-0 card-height-250">
              <SimpleList :data="metric" />
            </v-flex>
          </div>
        </v-container>
      </Card>
    </v-flex>
    <v-flex xs6>
      <Card class="footprint-card">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require(`../../assets/carbon_footprint/footprint.svg`)"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`../../assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <!-- saplings planted -->
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`../../assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
    </v-flex>
    <v-flex xs12>
      <DataCardSet :items="cardDataSet" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
const DataCardSet = () => import("@/components/Plant Overview New/DataCardSet");
import Chart from "@/components/common/Chart.vue";
import SimpleList from "@/components/common/SimpleList.vue";

export default {
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    generation: {
      type: Number,
      default: 0,
    },
    cardDataSet: {
      type: Array,
      default: function () {
        return [];
      },
    },
    lifeTimeGeneration: {
      type: [Number, String],
      default: 0,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Chart,
    SimpleList,
    DataCardSet,
  },
  data() {
    return {
      widgetList: [],
      instantaneousValue: [],
    };
  },
  async mounted() {
    this.getWidgetData();
  },
  computed: {
    ...mapGetters(["getSelectedPlantId"]),
    metric() {
      return this.instantaneousValue.map((item) => ({
        name: this.extractName(item.name),
        value: this.extractValue(item.name, item.value),
      }));
    },
    widgetData() {
      const tempObj = {};
      this.widgetList.forEach((item) => {
        tempObj[item.name] =
          item.value && item.value !== null && item.value !== "No Data"
            ? item.value.toFixed(2)
            : 0;
      });
      return tempObj;
    },
    carbonFootprint() {
      const co2EmissionLifeTime = (this.lifeTimeGeneration * 0.392) / 1000;
      const treeSapling = this.lifeTimeGeneration * 0.0117;
      const countCo2Decimal =
        this.countIntegersBeforeDecimal(co2EmissionLifeTime);
      const co2ComputedLifeTime = this.convertUnit(
        co2EmissionLifeTime,
        countCo2Decimal,
        "Tons"
      );
      const countTreeSaplingDecimal =
        this.countIntegersBeforeDecimal(treeSapling);
      const treeSaplingComputedLifeTime = this.convertToPower(
        treeSapling,
        countTreeSaplingDecimal
      );

      // TODAY's
      const co2EmissionToday = (this.generation * 0.392) / 1000;
      const treeSaplingToday = this.generation * 0.0117;
      const countCo2TodayDecimal =
        this.countIntegersBeforeDecimal(co2EmissionToday);
      const co2ComputedToday = this.convertUnit(
        co2EmissionToday,
        countCo2TodayDecimal,
        "Tons"
      );
      const countTreeSaplingTodayDecimal =
        this.countIntegersBeforeDecimal(treeSaplingToday);
      const treeSaplingComputedToday = this.convertToPower(
        treeSaplingToday,
        countTreeSaplingTodayDecimal
      );

      return {
        emission: {
          today: {
            data: this.generation
              ? co2ComputedToday.value.toFixed(2) : "-",
            unit: "Tons",
          },
          lifetime: {
            data: this.lifeTimeGeneration
              ? co2ComputedLifeTime.value.toFixed(2)
              : "-",
            unit: co2ComputedLifeTime.unit,
          },
        },
        sapling: {
          today: {
            data: this.generation
              ? treeSaplingComputedToday : "-",
            unit: "Nos",
          },
          lifetime: {
            data: this.lifeTimeGeneration ? treeSaplingComputedLifeTime : "-",
            unit: "Nos",
          },
        }
      }
    },
  },
  methods: {
    getWidgetData() {
      this.widgetList = [];
      this.instantaneousValue = [];
      this.items.forEach((el) => {
        if (
          el.name === "Plant Availability" ||
          el.name === "Grid Availability"
        ) {
          this.widgetList.push(el);
          return;
        }
        if (el.name === "Time") {
          this.instantaneousValue.push(
            {
              name: "Plant Start",
              value: el.value.startTime,
            },
            {
              name: "Plant Stop",
              value: el.value.stopTime,
            }
          );
          return;
        }
        this.instantaneousValue.push(el);
      });
    },
    countIntegersBeforeDecimal(number) {
      const stringRepresentation = number.toString();
      const indexOfDecimal = stringRepresentation.indexOf(".");

      if (indexOfDecimal !== -1) {
        return indexOfDecimal;
      } else {
        return stringRepresentation.length;
      }
    },
    extractName(name) {
      switch (name) {
        case "Instant Grid Availability":
          return this.$t("Grid Status");
        case "Instantaneous Plant Availability":
          return this.$t("Inst. PA (%)");
        case "Plant Down Time":
        case "Grid Down Time":
          return this.$t(name) + " (min)";
        default: {
          return this.$t(name);
        }
      }
    },
    extractValue(name, value) {
      switch (name) {
        case "Instant Grid Availability":
          if (value === true) {
            return "UP";
          } else if (value === false) {
            return "DOWN";
          } else {
            return "-";
          }
        default: {
          return value === "-" || !isNaN(parseFloat(value)) ? value : "-";
        }
      }
    },
    convertUnit(value, decimalCount, unit) {
      let computedUnit = "";
      if (decimalCount >= 4 && decimalCount < 6) {
        value = value / 1000;
        computedUnit = "k";
      }

      if (decimalCount >= 6 && decimalCount < 8) {
        value = value / 1000000;
        computedUnit = "M";
      }

      if (decimalCount >= 8) {
        value = value / 1000000000;
        computedUnit = "G";
      }

      computedUnit =
        computedUnit == "" ? unit : `${computedUnit}${unit}`;
      return {
        value: value,
        unit: computedUnit,
      };
    },
    convertToPower(value, decimalCount) {
      if (decimalCount >= 4) {
        const numbersBeforeDecimal = decimalCount - 2;
        return `${(value / Math.pow(10, numbersBeforeDecimal)).toFixed(
          0
        )} * 10 ^${numbersBeforeDecimal}`;
      } else {
        return value.toFixed(0);
      }
    },
  },
  watch: {
    items() {
      this.getWidgetData();
    },
  },
};
</script>

<style scoped>
.card-height-250 {
  min-height: 257px;
  max-height: 257px;
  overflow-y: auto;
}

.card-title {
  font-size: 15px;
  text-align: center;
  padding: 10px 0 4px 0;
  margin-bottom: 5px;
}

.custom-divider {
  background-color: #334079;
}

.availability-card {
  height: 270px;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.footprint-card {
  height: 270px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.carbon-footprint__value {
  color: #668cf6;
}

.carbon-footprint__power {
  font-size: 0.7em; /* Adjust font size for the superscript */
  vertical-align: super; /* Align the superscript text */
}

.carbon-footprint__unit {
  color: #aeaeae;
}

.theme--dark .carbon-footprint__title {
  color: #fff;
}

.theme--light .carbon-footprint__title {
  color: #000;
}

.theme--light .carbon-footprint__icon {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg)
    brightness(98%) contrast(86%);
}
</style>